"use client";

import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const historySlides = [{
  id: 1,
  title: "The Royal Decree",
  era: "17th Century",
  content: "The Cavalier King Charles Spaniel traces its noble roots back to the royal courts of Europe. They were the beloved companions of King Charles II, who was so devoted to the breed that he issued a royal decree allowing them in any public space, including Parliament—a decree that supposedly still stands today.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536339/img/vintage_cavalier_royal_court.png",
  imageClassName: "absolute inset-0 bg-primary/10 mix-blend-overlay z-10 transition-opacity duration-700 group-hover:opacity-0 !bg-[url(https://milehighcavaliers.10web.cloud/wp-content/uploads/2026/03/Rocky-Looking-down-scaled.jpg)]"
}, {
  id: 2,
  title: "A Renaissance Favorite",
  era: "16th - 18th Century",
  content: "Long before they were officially recognized, small toy spaniels were frequently depicted in masterpieces by renowned artists such as Titian, Gainsborough, and Van Dyck. These paintings serve as a historical record of the breed's enduring appeal among the aristocracy and their role as comforting lap dogs.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536339/img/vintage_cavalier_renaissance_painting.png"
}, {
  id: 3,
  title: "The Roswell Eldridge Revival",
  era: "1920s",
  content: "Over time, the breed evolved to have a flatter face, becoming the English Toy Spaniel. In the 1920s, an American named Roswell Eldridge traveled to England and offered a significant prize for spaniels resembling the older, longer-nosed type seen in early paintings, sparking the revival of the modern Cavalier.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536339/img/vintage_cavalier_eldridge_era.png"
}, {
  id: 4,
  title: "The Perfect Companion",
  era: "Modern Day",
  content: "Today, the Cavalier King Charles Spaniel is celebrated not just for its breathtaking beauty and silky coat, but for its unparalleled temperament. They are affectionate, gentle, and graceful, embodying the perfect balance of a sporty spaniel and a devoted lap dog, continuing their legacy as true royalty.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536339/img/modern_classic_cavalier_portrait.png"
}];
export default function AboutCavaliers() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  return;
}